import { Globe2, Check, ArrowRight, MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/i18n";

const ImportExport = ({ t, onOpenConsult }) => {
  const data = t.importExport;
  if (!data) return null;

  const waMessages = {
    pt: "Olá BID! Tenho interesse nas soluções de Importação & Exportação / Comex.",
    en: "Hello BID! I'm interested in your Import & Export / Comex solutions.",
    fr: "Bonjour BID ! Je suis intéressé(e) par vos solutions Import & Export / Comex.",
  };
  const langKey = t?.hero?.cta === "Book Technical Consulting" ? "en" : t?.hero?.cta === "Planifier une consultation" ? "fr" : "pt";
  const waMessage = encodeURIComponent(waMessages[langKey] || waMessages.pt);
  const waHref = `https://wa.me/${CONTACT.whatsappRaw}?text=${waMessage}`;

  return (
    <section
      id="comex"
      className="relative bg-[#060d18] text-white py-24 sm:py-32 overflow-hidden border-t border-white/5"
    >
      <div className="absolute top-0 right-0 p-32 opacity-20 pointer-events-none">
        <div className="w-[500px] h-[500px] bg-[#d4af37]/20 rounded-full blur-[100px]" />
      </div>

      <div className="relative bid-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          <div className="max-w-xl">
            <p className="bid-overline text-[#d4af37] mb-4">{data.overline}</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-black tracking-tight leading-tight mb-6">
              {data.title}
            </h2>
            <p className="text-lg text-white/70 leading-relaxed mb-10">
              {data.description}
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4 mb-4">
              <button
                onClick={onOpenConsult}
                className="btn-primary"
              >
                {data.cta}
                <ArrowRight className="w-4 h-4 ml-2" />
              </button>
              <a
                href={waHref}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary"
              >
                <MessageCircle className="w-4 h-4 mr-2" />
                WhatsApp
              </a>
            </div>
          </div>

          <div className="bg-[#0a192f] border border-white/10 rounded-2xl p-8 lg:p-12 shadow-2xl relative overflow-hidden group hover:border-[#d4af37]/50 transition-colors duration-500">
            <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-[#d4af37]/10 border border-[#d4af37]/30 mb-8 transform group-hover:scale-110 transition-transform duration-500">
              <Globe2 className="w-8 h-8 text-[#d4af37]" />
            </div>
            <ul className="space-y-4">
              {data.features.map((feature, idx) => (
                <li key={idx} className="flex gap-4 items-start text-white/80 text-base">
                  <Check className="w-5 h-5 text-[#d4af37] mt-0.5 flex-shrink-0" strokeWidth={3} />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ImportExport;
